import React from "react";

import './Button.css'

export type ButtonProps = {
    text: JSX.Element | string,
    onClick: (_: any) => void,
    backgroundColor: string
    textColor: string
}

export function AdaptiveButton(props: ButtonProps) {
    const textStyle = {color: props.textColor};
    const buttonStyle = {background: props.backgroundColor};
    
    return <button className="empty-button wa-button" style={buttonStyle} onClick={props.onClick}>
        <span className="flex-center wa-button-text" style={textStyle}>{props.text}</span>
    </button>
}

export function Button(props: ButtonProps) {
    return <div className="button-outer">
        <AdaptiveButton {...props} />
    </div>
}
